import world from './widgets/world';

export default {
  init() {
    world.init();
  },

  destroy() {},
};
